import type { ReactNode } from 'react';
import SiteHeader from './SiteHeader';
import SiteFooter from './SiteFooter';
import BackToTop from './BackToTop';

type SiteLayoutProps = {
  children: ReactNode;
};

const SiteLayout = ({ children }: SiteLayoutProps) => (
  <div className="flex min-h-screen flex-col bg-background-50">
    <SiteHeader />
    <main className="flex-1">{children}</main>
    <SiteFooter />
    <BackToTop />
  </div>
);

export default SiteLayout;